import { render } from "./OrderDiscountsPanel.vue?vue&type=template&id=d695f14a&scoped=true&ts=true&lang=pug"
import script from "./OrderDiscountsPanel.vue?vue&type=script&lang=ts"
export * from "./OrderDiscountsPanel.vue?vue&type=script&lang=ts"

import "./OrderDiscountsPanel.vue?vue&type=style&index=0&id=d695f14a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d695f14a"]])

export default __exports__